"use client";

import Link from "next/link";
import { ArrowRight, MessageSquare } from "lucide-react";
import Section from "@/components/public/Section";

export function PreFooterCta() {
  return (
    <Section spacing="normal" background="transparent" bottomPadding="pb-4 sm:pb-6 lg:pb-8">
      <div className="px-4 lg:px-6">
        <div className="relative overflow-hidden rounded-3xl border border-gray-200 bg-white shadow-[0_14px_36px_-28px_rgba(15,23,42,0.35)]">
          <div className="absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r from-emerald-400 via-blue-500 to-purple-500" />

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-start p-5 sm:p-7 lg:p-8">
            <div className="lg:col-span-8">
              <span className="inline-flex items-center gap-2 rounded-full bg-purple-50 border border-purple-200 text-purple-700 px-3 py-1 text-xs font-semibold uppercase tracking-wider mb-4">
                <MessageSquare className="w-3.5 h-3.5" />
                Get in touch
              </span>

              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black text-gray-900 mb-3 leading-tight">
                Planning improvements across your properties?
              </h2>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed max-w-4xl">
                Speak with the Replenico team to discuss your current setup, get practical recommendations, and choose the right next step for your operation.
              </p>

              <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-2.5 max-w-3xl">
                {[
                  "Advice tailored to your portfolio",
                  "Clear implementation options",
                  "Direct support from specialists",
                  "No-obligation conversation",
                ].map((point) => (
                  <div key={point} className="rounded-xl border border-gray-200 bg-gray-50 px-3.5 py-2.5 text-sm text-gray-700">
                    {point}
                  </div>
                ))}
              </div>
            </div>

            <div className="lg:col-span-4">
              <div className="rounded-2xl border border-gray-200 bg-white p-4 sm:p-5 shadow-sm">
                <p className="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-2">
                  Choose how to connect
                </p>
                <p className="text-sm text-gray-600 leading-relaxed mb-4">
                  Send an enquiry or book a call. We will respond with the right guidance for your team.
                </p>

                <div className="space-y-2.5">
                  <Link
                    href="/contact"
                    className="inline-flex w-full items-center justify-center gap-2 px-6 py-3 rounded-xl font-semibold text-white text-base transition-all duration-200 hover:shadow-md hover:brightness-105"
                    style={{ backgroundColor: "#8c52ff" }}
                  >
                    Contact us
                    <ArrowRight className="w-4 h-4" />
                  </Link>
                  <Link
                    href="/book-a-demo"
                    className="inline-flex w-full items-center justify-center px-6 py-3 rounded-xl font-semibold text-base border border-gray-300 text-gray-700 hover:bg-gray-50 transition-all duration-200"
                  >
                    Book a call
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}
